import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

import {
	RECOMMEND_TO_FREE_ANALYTICS_SOURCE,
	RECOMMEND_TO_FREE_STATSIG_EXPERIMENT,
} from '../package-constants';
import { getCohortValue } from '../utils/check-experiment-data';

export function useFireExperimentExposureAndAnalytics() {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const cohort = getCohortValue();

	const [, fireRecommendToFreeStatsigExperiment] = UNSAFE_noExposureExp(
		'confluence_recommend_trial_to_free_ab',
	);

	const fireExposure = useCallback(() => {
		void fireRecommendToFreeStatsigExperiment();

		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'exposed',
				actionSubject: 'feature',
				source: RECOMMEND_TO_FREE_ANALYTICS_SOURCE,
				attributes: {
					cohort,
					flagKey: RECOMMEND_TO_FREE_STATSIG_EXPERIMENT,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, cohort, fireRecommendToFreeStatsigExperiment]);

	return { fireExposure };
}
